// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3f6bN","detailsBorder":"styles_detailsBorder__2Wv6Z"};